import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPriceGroup } from "src/models/Prices/PriceGroup.models";

interface PriceGroupState {
  priceGroups: IPriceGroup[];
  priceGroupToEdit: IPriceGroup | null;
}

const initialState: PriceGroupState = {
  priceGroups: [],
  priceGroupToEdit: null,
};

const PriceGroupSlice = createSlice({
  name: "PriceGroup",
  initialState,
  reducers: {
    setPriceGroupList: (state, action: PayloadAction<IPriceGroup[]>) => {
      state.priceGroups = action.payload;
    },
    concatListPriceGroup: (
      state: PriceGroupState,
      action: PayloadAction<IPriceGroup[]>
    ) => {
      state.priceGroups = [...state.priceGroups.concat(action.payload)];
    },
    setPriceGroupToEdit: (state, action: PayloadAction<IPriceGroup | null>) => {
      state.priceGroupToEdit = action.payload;
    },
    addPriceGroup: (state, action: PayloadAction<IPriceGroup>) => {
      state.priceGroups.push(action.payload);
    },
    updatePriceGroup: (state, action: PayloadAction<IPriceGroup>) => {
      let itemIndex = state.priceGroups.findIndex(
        item => item.priceGroupId === action.payload.priceGroupId
      );
      if (itemIndex !== -1) state.priceGroups[itemIndex] = action.payload;
    },
    deletePriceGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.priceGroups.filter(
        item => item.priceGroupId !== action.payload
      );
      state.priceGroups = newArray;
    },
  },
});

export const {
  setPriceGroupList,
  concatListPriceGroup,
  setPriceGroupToEdit,
  addPriceGroup,
  updatePriceGroup,
  deletePriceGroup,
} = PriceGroupSlice.actions;

export default PriceGroupSlice.reducer;
